import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createBlock as _createBlock } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = {
  key: 1,
  class: "not-found"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", null, "This service is not available in your current region...", -1)
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = {
  key: 2,
  class: "app-page"
}
const _hoisted_6 = { class: "app-item-list" }
const _hoisted_7 = {
  key: 0,
  class: "logout-wrap"
}
const _hoisted_8 = {
  key: 1,
  class: "logout-mask"
}
const _hoisted_9 = { class: "logout-dialog" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("p", null, "Are you sure you want to log out?", -1)
const _hoisted_11 = { class: "logout-actions" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_HelloWorld = _resolveComponent("HelloWorld")!

  return (_ctx.needLoading === 1)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, "Loading..."))
    : (_ctx.needLoading === -1)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, _hoisted_4))
      : (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.appList, (el) => {
              return (_openBlock(), _createBlock(_component_HelloWorld, {
                key: el.id,
                order: el.last_order || {},
                app: el
              }, null, 8, ["order", "app"]))
            }), 128))
          ]),
          (_ctx.isAll)
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                _createElementVNode("button", {
                  class: "logout-btn",
                  type: "button",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showLogoutConfirm = true))
                }, " Logout ")
              ]))
            : _createCommentVNode("", true),
          (_ctx.showLogoutConfirm)
            ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                _createElementVNode("div", _hoisted_9, [
                  _hoisted_10,
                  _createElementVNode("div", _hoisted_11, [
                    _createElementVNode("button", {
                      class: "cancel-btn",
                      type: "button",
                      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showLogoutConfirm = false))
                    }, " Cancel "),
                    _createElementVNode("button", {
                      class: "confirm-btn",
                      type: "button",
                      onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.logout && _ctx.logout(...args)))
                    }, " Confirm ")
                  ])
                ])
              ]))
            : _createCommentVNode("", true)
        ]))
}